import script from "./componentList.vue?vue&type=script&lang=js"
export * from "./componentList.vue?vue&type=script&lang=js"

import "./componentList.vue?vue&type=style&index=0&id=1dd73318&lang=css"

const __exports__ = script;

export default __exports__